import { endpoints } from "src/utils/axios";

import { createListHook, createObjectHook } from "src/actions/utils/create-action";


/**
 * Hook to fetch current user's organization types and their details
 * @param {Object} args - Fetch arguments (params, config, etc.)
 * @returns {Object} { data, loading, error, validating, empty, refresh }
 */
export const useGetMyOrgTypes = createObjectHook(endpoints.me.orgTypes);

export const useGetMyOrgBrands = createListHook(`${endpoints.me.orgTypes}/brand`);